import { useTranslation } from 'react-i18next'
import { Phone, Mail, MapPin } from 'lucide-react'

export function ContactSection() {
  const { t } = useTranslation('common')

  return (
    <section className="section-padding bg-white" aria-labelledby="contact-title">
      <div className="container-fiorucci">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 id="contact-title" className="heading-section text-[#4E2118] mb-4">
              {t('careers.contact.title')}
            </h2>
            <p className="text-[#4E2118]/70">
              {t('careers.contact.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
            {/* Map */}
            <div className="flex flex-col">
              <h3 className="text-lg font-semibold text-[#4E2118] mb-4">
                {t('careers.contact.mapTitle')}
              </h3>
              <div className="flex-1 rounded-2xl overflow-hidden shadow-lg border border-[#F3E4D6] min-h-[320px]">
                <iframe
                  title={t('careers.contact.mapTitle')}
                  src="https://maps.google.com/maps?q=Fiorucci+S.p.A.+Santa+Palomba+Pomezia&t=&z=14&ie=UTF8&iwloc=B&output=embed"
                  className="w-full h-full min-h-[320px]"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            {/* Contact Cards */}
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-semibold text-[#4E2118] mb-0 lg:mb-0">
                {t('careers.contact.infoTitle')}
              </h3>

              {/* Phone */}
              <a
                href="tel:+3906911931"
                className="group flex items-center gap-5 p-6 bg-[#FDF8F3] rounded-xl border border-[#F3E4D6] hover:border-[#DF631E]/30 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-14 h-14 bg-[#DF631E]/10 rounded-full flex items-center justify-center group-hover:bg-[#DF631E] transition-colors duration-300">
                  <Phone className="w-6 h-6 text-[#DF631E] group-hover:text-white transition-colors duration-300" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#4E2118] mb-1">{t('careers.contact.phone')}</h3>
                  <p className="text-[#DF631E] font-medium">+39 06911931</p>
                </div>
              </a>

              {/* Email */}
              <a
                href="mailto:info@fioruccifood.it"
                className="group flex items-center gap-5 p-6 bg-[#FDF8F3] rounded-xl border border-[#F3E4D6] hover:border-[#DF631E]/30 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-14 h-14 bg-[#DF631E]/10 rounded-full flex items-center justify-center group-hover:bg-[#DF631E] transition-colors duration-300">
                  <Mail className="w-6 h-6 text-[#DF631E] group-hover:text-white transition-colors duration-300" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#4E2118] mb-1">{t('careers.contact.email')}</h3>
                  <p className="text-[#DF631E] font-medium">info@fioruccifood.it</p>
                </div>
              </a>

              {/* Location */}
              <div className="group flex items-center gap-5 p-6 bg-[#FDF8F3] rounded-xl border border-[#F3E4D6]">
                <div className="w-14 h-14 bg-[#DF631E]/10 rounded-full flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-[#DF631E]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#4E2118] mb-1">{t('careers.contact.location')}</h3>
                  <p className="text-[#4E2118]/70 text-sm">
                    {t('careers.contact.address')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
